// Breakpoints for the chat layout - component-specific breakpoints.
export enum ChatBreakpoints {
  SMALL = 940,
  LARGE = 1600,
}
